module.exports = __webpack_public_path__ + "img/website.646fa752.png";